export type VideoType = "movie" | "short";

export interface Video {
  id: string;
  title: string;
  type: VideoType;
  category: string;
  region: string;
  year: number;
  duration: number;
  publishDate: string;
  views: number;
  rating: number;
  director: string;
  producer: string;
  cast: string[];
  summary: string;
  description: string;
  tags: string[];
  cover: string;
}

export const videos: Video[] = [
  {
    id: "v-001",
    title: "午夜玫瑰",
    type: "movie",
    category: "激情电影",
    region: "中国大陆",
    year: 2025,
    duration: 98,
    publishDate: "2025-09-28",
    views: 1286000,
    rating: 8.6,
    director: "陆明远",
    producer: "星澜影业",
    cast: ["许清妍", "周牧野", "林知夏"],
    summary: "一间只在深夜营业的花店，两个各怀心事的陌生人，在玫瑰香气里展开一场关于勇气与欲望的对话。",
    description:
      "《午夜玫瑰》以一间深夜花店为舞台，讲述都市白领苏晚在连续加班的深夜偶遇花店主人程野的故事。两人的相遇看似偶然，实则是彼此生活裂缝中透出的光。影片以细腻的镜头语言记录了一整夜里从试探、靠近到坦诚的全过程，配合城市霓虹与花瓣特写的交错剪辑，呈现出都市情感题材少见的克制与浪漫。片中大量夜戏采用实景拍摄，自然光与暖调灯光相融，让整部作品拥有极强的呼吸感。",
    tags: ["都市情感", "浪漫", "夜戏"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20moody%20portrait%20poster%20of%20a%20deep%20crimson%20rose%20in%20front%20of%20a%20neon%20lit%20city%20window%20at%20midnight%2C%20dark%20charcoal%20background%2C%20dramatic%20red%20and%20amber%20lighting%2C%20elegant%20film%20poster%20art%2C%20high%20contrast%2C%20atmospheric%20shadows&width=600&height=800&seq=passion-cover-001&orientation=portrait",
  },
  {
    id: "v-002",
    title: "霓虹之下",
    type: "movie",
    category: "激情电影",
    region: "中国香港",
    year: 2024,
    duration: 112,
    publishDate: "2025-09-20",
    views: 2143000,
    rating: 8.9,
    director: "陈启行",
    producer: "维港映像",
    cast: ["何嘉言", "叶蔓", "张叙白"],
    summary: "霓虹灯牌下的老城区，一位爵士歌手与一位摄影记者在雨夜里交换了彼此的秘密。",
    description:
      "老城区即将拆迁，最后的霓虹作坊里，歌手阿蔓坚持唱完最后一场演出。摄影记者阿言带着任务是来记录这场落幕，却在镜头里发现了自己遗失多年的心动。《霓虹之下》用大量长镜头串联街区巷弄，红与金的灯光在雨幕中晕开，构成一幅关于城市与人的情感长卷。片中爵士乐全部现场收音，音乐与画面互为呼吸。",
    tags: ["年代", "都市情感", "音乐"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20rainy%20hong%20kong%20alley%20with%20glowing%20red%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20dark%20black%20night%20atmosphere%2C%20dramatic%20amber%20rim%20light%2C%20moody%20artistic%20photography%2C%20elegant%20composition&width=600&height=800&seq=passion-cover-002&orientation=portrait",
  },
  {
    id: "v-003",
    title: "她的香气",
    type: "movie",
    category: "激情电影",
    region: "韩国",
    year: 2025,
    duration: 104,
    publishDate: "2025-09-15",
    views: 1892000,
    rating: 8.4,
    director: "金泰俊",
    producer: "首尔光影工作室",
    cast: ["朴瑞妍", "李道勋", "崔智恩"],
    summary: "调香师为一段旧情调制出最后一款香水，气味成为她与过去和解的唯一方式。",
    description:
      "调香师瑞妍接到一份特殊订单：为十年后的自己调一款香水。在翻阅配方笔记的过程中，她重新走入那段早已封存的夏日。影片以气味作为叙事线索，将苔藓、橙花、雪松的层次转化为视觉色谱，画面从暖白逐渐过渡到深红，完成一次关于记忆与放下的温柔告别。",
    tags: ["文艺", "都市情感", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=artistic%20film%20poster%20of%20elegant%20glass%20perfume%20bottle%20on%20dark%20marble%20surface%20with%20soft%20smoke%20and%20amber%20light%20rays%2C%20deep%20burgundy%20background%2C%20luxury%20minimalist%20moody%20product%20photography%2C%20high%20end%20cinematic%20look&width=600&height=800&seq=passion-cover-003&orientation=portrait",
  },
  {
    id: "v-004",
    title: "热浪之城",
    type: "movie",
    category: "激情电影",
    region: "泰国",
    year: 2024,
    duration: 121,
    publishDate: "2025-09-08",
    views: 3120000,
    rating: 9.1,
    director: "P. Somchai",
    producer: "Bangkok Frame",
    cast: ["Nara", "Kit", "Anan"],
    summary: "曼谷雨季前的最后一周，三位年轻人在天台上度过了一个改变彼此的夏天。",
    description:
      "《热浪之城》把镜头对准曼谷老城的天台与巷口，三个不同背景的年轻人在同一栋楼里相遇。湿热的风、融化的冰块、反复播放的黑胶唱片，构成整部影片的呼吸节奏。导演用近乎纪录式的自然光拍摄，让每一次沉默与对话都显得真实可信，成为当年亚洲影展的惊喜之作。",
    tags: ["青春", "夏日", "成长"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20bangkok%20rooftop%20at%20golden%20hour%20with%20heat%20haze%20and%20orange%20crimson%20sky%2C%20silhouetted%20city%20skyline%2C%20warm%20dusty%20atmosphere%2C%20film%20grain%20texture%2C%20dramatic%20editorial%20photography&width=600&height=800&seq=passion-cover-004&orientation=portrait",
  },
  {
    id: "v-005",
    title: "暗涌",
    type: "movie",
    category: "激情电影",
    region: "中国大陆",
    year: 2023,
    duration: 108,
    publishDate: "2025-08-30",
    views: 1654000,
    rating: 8.2,
    director: "孙砚",
    producer: "蓝汐影视",
    cast: ["周斯羽", "沈蔚", "顾宸"],
    summary: "一次意外重逢，让两颗早已平静的心重新掀起暗涌。",
    description:
      "多年未见的大学同窗，在一场行业论坛上意外重逢。两人都已各自有了生活，但那天下午的咖啡馆与走廊里未出口的话，让所有克制都显得摇摇欲坠。《暗涌》以大量手持近景表现人物内心的细微波动，配乐极简，几乎由环境音构成，营造出极强的沉浸感。",
    tags: ["都市情感", "悬疑", "重逢"],
    cover: "https://readdy.ai/api/search-image?query=moody%20cinematic%20poster%20of%20two%20empty%20coffee%20cups%20on%20a%20dark%20wooden%20table%20beside%20rain%20streaked%20glass%2C%20deep%20red%20and%20charcoal%20tones%2C%20low%20key%20lighting%2C%20minimal%20elegant%20composition%2C%20atmospheric%20film%20still&width=600&height=800&seq=passion-cover-005&orientation=portrait",
  },
  {
    id: "v-006",
    title: "唇间密语",
    type: "movie",
    category: "激情电影",
    region: "日本",
    year: 2024,
    duration: 96,
    publishDate: "2025-08-22",
    views: 1420000,
    rating: 8.0,
    director: "森田启",
    producer: "东京夜行社",
    cast: ["水野绫", "高桥凉", "佐伯遥"],
    summary: "深夜广播电台的女主播，收到一封写给十年前的自己的信。",
    description:
      "女主角每晚负责一档深夜情感节目，某天她收到一封没有署名的信，内容却精准描述了她十年前的秘密。《唇间密语》将广播电波、城市夜景与内心独白三条线索交织，在温柔的声线里讲述一段未完成的情感。收音细节极其考究，戴上耳机观看体验更佳。",
    tags: ["文艺", "广播", "都市情感"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20vintage%20radio%20microphone%20in%20a%20dark%20studio%20with%20warm%20red%20glow%20and%20haze%2C%20late%20night%20city%20lights%20blurred%20in%20background%2C%20moody%20analog%20film%20aesthetic%2C%20elegant%20minimal%20design&width=600&height=800&seq=passion-cover-006&orientation=portrait",
  },
  {
    id: "v-007",
    title: "红裙之夜",
    type: "movie",
    category: "激情电影",
    region: "中国香港",
    year: 2025,
    duration: 116,
    publishDate: "2025-08-14",
    views: 2680000,
    rating: 8.7,
    director: "梁允中",
    producer: "南岸电影",
    cast: ["苏婧", "欧阳信", "文汀"],
    summary: "一场慈善晚宴，一条红裙，改变了一个女人全部的人生轨迹。",
    description:
      "慈善晚宴上的意外停电，让所有人看见了平日里看不见的东西。女主角穿上那条象征勇气的红裙，在舞池中央做出了一生中最重要的决定。《红裙之夜》以华丽的美术设计与精准的群像调度著称，镜面地板的倒影反复出现，暗示人物真实自我与公众形象的分裂。",
    tags: ["都市情感", "时尚", "剧情"],
    cover: "https://readdy.ai/api/search-image?query=elegant%20cinematic%20poster%20of%20a%20flowing%20crimson%20silk%20dress%20swirling%20in%20dark%20ballroom%20with%20chandelier%20bokeh%2C%20deep%20black%20background%2C%20dramatic%20spotlight%2C%20luxury%20fashion%20editorial%20photography%2C%20rich%20red%20and%20gold%20tones&width=600&height=800&seq=passion-cover-007&orientation=portrait",
  },
  {
    id: "v-008",
    title: "边缘温度",
    type: "movie",
    category: "激情电影",
    region: "法国",
    year: 2023,
    duration: 124,
    publishDate: "2025-08-05",
    views: 980000,
    rating: 8.3,
    director: "Julien Marchand",
    producer: "Rive Gauche",
    cast: ["Camille Roux", "Étienne Vale", "Louise Bard"],
    summary: "塞纳河左岸的一间旧书店，收藏着两代人关于爱的全部注解。",
    description:
      "旧书店的阁楼里，女主角发现一叠未寄出的信。她循着信中的地址，走进另一段横跨二十年的故事。影片在巴黎的街区取景，用自然光与手写字体进行转场，文字与影像互为注脚，呈现出欧洲文艺片特有的松弛与深情。",
    tags: ["文艺", "书店", "跨年代"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20warm%20old%20bookshop%20interior%20with%20stacked%20leather%20books%20and%20golden%20lamp%20light%2C%20dust%20particles%20in%20sunbeams%2C%20dark%20mahogany%20wood%20tones%2C%20nostalgic%20european%20film%20aesthetic&width=600&height=800&seq=passion-cover-008&orientation=portrait",
  },
  {
    id: "v-009",
    title: "午夜心跳·第一季",
    type: "short",
    category: "激情短视频",
    region: "中国大陆",
    year: 2025,
    duration: 8,
    publishDate: "2025-10-12",
    views: 4260000,
    rating: 9.0,
    director: "方南",
    producer: "激情视频自制",
    cast: ["林晓", "宋辞"],
    summary: "电梯停摆的三十秒里，两个人对视的每一帧都像心跳。",
    description:
      "《午夜心跳》系列以极短篇幅呈现都市中的心动瞬间，每一集聚焦一个具体场景：电梯、便利店、末班车、雨棚。第一季共十二集，全部采用一镜到底拍摄，配合氛围电子配乐，用最短的时间讲一个最完整的心动故事。",
    tags: ["都市情感", "一镜到底", "氛围感"],
    cover: "https://readdy.ai/api/search-image?query=moody%20vertical%20poster%20of%20a%20dim%20elevator%20corridor%20with%20red%20emergency%20light%2C%20two%20silhouettes%20facing%20each%20other%2C%20cinematic%20shallow%20depth%20of%20field%2C%20dark%20atmosphere%2C%20warm%20crimson%20glow%2C%20modern%20minimal%20photography&width=600&height=800&seq=passion-cover-009&orientation=portrait",
  },
  {
    id: "v-010",
    title: "深夜便利店",
    type: "short",
    category: "激情短视频",
    region: "中国大陆",
    year: 2025,
    duration: 12,
    publishDate: "2025-10-10",
    views: 3520000,
    rating: 8.8,
    director: "程夏",
    producer: "激情视频自制",
    cast: ["苏可", "闻舟"],
    summary: "凌晨三点的便利店，是所有孤独心事的中转站。",
    description:
      "夜班店员与每晚准时来买关东煮的常客，在货架之间完成了一场无需言语的对话。影片用一个完整的长镜头记录十二分钟的真实时间，货架灯、冰柜嗡鸣与偶尔驶过的车灯，构成最真实的生活质感。",
    tags: ["治愈", "夜戏", "生活流"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20late%20night%20convenience%20store%20glowing%20warm%20amber%20light%2C%20empty%20street%20reflecting%20signage%2C%20dark%20blue%20black%20night%2C%20lonely%20urban%20mood%2C%20film%20grain%2C%20artistic%20photography&width=600&height=800&seq=passion-cover-010&orientation=portrait",
  },
  {
    id: "v-011",
    title: "心跳的频率",
    type: "short",
    category: "激情短视频",
    region: "韩国",
    year: 2024,
    duration: 10,
    publishDate: "2025-10-06",
    views: 2980000,
    rating: 8.5,
    director: "尹智浩",
    producer: "Studio Beat",
    cast: ["金敏书", "郑宇镇"],
    summary: "音乐教室里的一段钢琴合奏，弹出了两个人同频的心跳。",
    description:
      "女主角为了比赛练习到深夜，男主角带着一把小提琴出现。两种乐器从对抗到融合的过程，就是两人关系推进的隐喻。全片以四手联弹为核心场景，收音与剪辑节奏高度契合，让音乐成为最强的情节推动力。",
    tags: ["音乐", "青春", "双人合奏"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20grand%20piano%20in%20a%20dark%20music%20room%20lit%20by%20a%20single%20warm%20lamp%2C%20sheet%20music%20scattered%2C%20deep%20red%20curtains%2C%20elegant%20moody%20atmosphere%2C%20soft%20film%20grain&width=600&height=800&seq=passion-cover-011&orientation=portrait",
  },
  {
    id: "v-012",
    title: "唇印",
    type: "short",
    category: "激情短视频",
    region: "中国香港",
    year: 2025,
    duration: 6,
    publishDate: "2025-10-03",
    views: 5100000,
    rating: 9.2,
    director: "何思远",
    producer: "激情视频自制",
    cast: ["叶晴", "陆行"],
    summary: "一杯咖啡上的唇印，成了整晚最后一句告白。",
    description:
      "六分钟，一杯咖啡，一句台词。全片只用一个固定机位完成，靠光影与人物表演撑起全部张力。女主角离开后，镜头停在杯口那枚红色的唇印上，长达二十秒的静止画面成为整个系列最被讨论的结尾。",
    tags: ["一镜到底", "都市情感", "极短篇"],
    cover: "https://readdy.ai/api/search-image?query=minimal%20cinematic%20poster%20of%20a%20white%20coffee%20cup%20with%20red%20lipstick%20mark%20on%20a%20dark%20cafe%20table%2C%20single%20warm%20spotlight%2C%20deep%20black%20background%2C%20high%20contrast%20minimalist%20product%20photography%2C%20elegant%20red%20accents&width=600&height=800&seq=passion-cover-012&orientation=portrait",
  },
  {
    id: "v-013",
    title: "雨夜出租车",
    type: "short",
    category: "激情短视频",
    region: "日本",
    year: 2025,
    duration: 15,
    publishDate: "2025-09-30",
    views: 2740000,
    rating: 8.6,
    director: "中村绫",
    producer: "Nighthawk Films",
    cast: ["松本遥", "大野圭"],
    summary: "一场雨、一段车程，乘客和司机说完了这辈子最长的一段话。",
    description:
      "车内视角是《雨夜出租车》最鲜明的特点。后视镜里的眼神、雨刷的节奏、窗外流动的灯，让十五分钟的车程像一部完整的公路电影。剧本只写了一页纸，大部分对白来自演员的即兴。",
    tags: ["夜戏", "公路", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20taxi%20window%20covered%20in%20raindrops%20at%20night%20with%20blurred%20red%20street%20lights%20bokeh%2C%20dark%20moody%20urban%20atmosphere%2C%20high%20contrast%20amber%20and%20crimson%20tones%2C%20film%20still&width=600&height=800&seq=passion-cover-013&orientation=portrait",
  },
  {
    id: "v-014",
    title: "天台的风",
    type: "short",
    category: "激情短视频",
    region: "泰达",
    year: 2024,
    duration: 9,
    publishDate: "2025-09-25",
    views: 2130000,
    rating: 8.1,
    director: "Nara P.",
    producer: "Rooftop Collective",
    cast: ["Mai", "Tern"],
    summary: "毕业前的最后一个傍晚，天台上说了所有不敢说的话。",
    description:
      "全片在日落黄金时段拍摄，风把所有道具都吹得凌乱，导演索性保留这些意外，让影片拥有难以复制的真实感。两个人的对话从天气开始，最后落在了一句没有回答的问题上。",
    tags: ["青春", "日落", "成长"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20rooftop%20washing%20line%20with%20sheets%20blowing%20in%20warm%20sunset%20wind%2C%20dusty%20orange%20and%20crimson%20sky%2C%20city%20rooftops%20silhouette%2C%20nostalgic%20film%20grain%20aesthetic&width=600&height=800&seq=passion-cover-014&orientation=portrait",
  },
  {
    id: "v-015",
    title: "暗巷灯火",
    type: "short",
    category: "激情短视频",
    region: "中国香港",
    year: 2025,
    duration: 11,
    publishDate: "2025-09-18",
    views: 1890000,
    rating: 8.0,
    director: "谭公义",
    producer: "旧城计划",
    cast: ["阿岚", "阿森"],
    summary: "巷子尽头的灯火下，两个人终于说清了那年的误会。",
    description:
      "《暗巷灯火》以一条真实存在的老巷为唯一场景，用手持镜头跟随人物来回走动。昏黄的巷灯、晃动的影子与偶尔路过的小猫，构成了这部作品最动人的细节。",
    tags: ["旧城", "重逢", "夜戏"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20narrow%20old%20alley%20at%20night%20lit%20by%20a%20single%20warm%20yellow%20street%20lamp%2C%20wet%20stone%20pavement%2C%20deep%20shadows%2C%20red%20hue%20in%20darkness%2C%20moody%20urban%20photography&width=600&height=800&seq=passion-cover-015&orientation=portrait",
  },
  {
    id: "v-016",
    title: "慢镜头之吻",
    type: "short",
    category: "激情短视频",
    region: "中国大陆",
    year: 2025,
    duration: 7,
    publishDate: "2025-09-12",
    views: 4680000,
    rating: 9.1,
    director: "程夏",
    producer: "激情视频自制",
    cast: ["苏可", "闻舟"],
    summary: "用120帧记录七秒，把一次心动拉到最长。",
    description:
      "全片采用120帧高帧率拍摄，七秒钟的动作被延展成七分钟的观感。光影在皮肤上的流动、发丝的下落、眼神的靠近，都被彻底放大。这部作品也是本站「高帧美学」专题的代表作。",
    tags: ["高帧率", "氛围感", "极短篇"],
    cover: "https://readdy.ai/api/search-image?query=abstract%20cinematic%20poster%20of%20slow%20motion%20silk%20fabric%20flowing%20in%20deep%20crimson%20light%2C%20soft%20blur%20and%20bokeh%2C%20dark%20charcoal%20background%2C%20elegant%20artistic%20photography%2C%20high%20contrast%20red%20tones&width=600&height=800&seq=passion-cover-016&orientation=portrait",
  },
  {
    id: "v-017",
    title: "欲望旅馆",
    type: "movie",
    category: "热门主题",
    region: "西班牙",
    year: 2024,
    duration: 133,
    publishDate: "2025-09-05",
    views: 3980000,
    rating: 9.3,
    director: "Alvaro Ruiz",
    producer: "Costa Films",
    cast: ["Elena Vidal", "Marco Sol", "Inés Roca"],
    summary: "一间海边旅馆，六个房间，六段在同一夜里交错的命运。",
    description:
      "《欲望旅馆》采用六线并行的结构，每个房间都是一个独立的故事，走廊与电梯成为六条线的交汇点。导演用同一个长镜头在房间之间穿梭，形成极强的空间连续性。影片在美术与色彩上高度统一，全部场景以暖红与墨绿为主色，被评为年度最具设计感的作品之一。",
    tags: ["群像", "结构叙事", "海边"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20vintage%20hotel%20corridor%20with%20deep%20red%20carpet%20and%20warm%20wall%20sconces%2C%20numbered%20doors%2C%20perspective%20vanishing%20point%2C%20moody%20luxury%20interior%2C%20film%20still%20aesthetic&width=600&height=800&seq=passion-cover-017&orientation=portrait",
  },
  {
    id: "v-018",
    title: "夜色温柔",
    type: "movie",
    category: "热门主题",
    region: "中国台湾",
    year: 2025,
    duration: 107,
    publishDate: "2025-08-28",
    views: 2450000,
    rating: 8.8,
    director: "杨以安",
    producer: "岛屿影画",
    cast: ["林宛静", "黄其远", "吴念"],
    summary: "海边的最后一个夏天，所有告别都发生在深夜。",
    description:
      "女主角在父亲留下的海边小屋度过最后一个夏天，与邻村的男生一起修好了一艘旧船。《夜色温柔》以极慢的节奏讲述告别，长镜头下的海浪与蝉鸣几乎是全片的叙事者。影片结尾，小船驶入夜色，长镜头停留两分钟，成为许多观众记忆最深的段落。",
    tags: ["海边", "成长", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20small%20wooden%20boat%20on%20a%20dark%20sea%20under%20deep%20red%20dusk%20sky%2C%20gentle%20waves%20and%20mist%2C%20minimal%20melancholic%20composition%2C%20soft%20film%20grain%2C%20artistic%20photography&width=600&height=800&seq=passion-cover-018&orientation=portrait",
  },
  {
    id: "v-019",
    title: "红色房间",
    type: "movie",
    category: "热门主题",
    region: "意大利",
    year: 2023,
    duration: 118,
    publishDate: "2025-08-18",
    views: 1720000,
    rating: 8.5,
    director: "Luca Ferri",
    producer: "Studio Rosso",
    cast: ["Giulia Neri", "Dario Conti"],
    summary: "一间全红的房子里，两个人用一整夜谈论爱、恐惧与自由。",
    description:
      "《红色房间》是一部几乎完全发生在单一空间的对话电影。墙壁、沙发、窗帘全部为不同层次的红色，随着对话深入，灯光逐渐暗下，色彩也随之转为深褐。影片依靠两位演员的表演与精准的台词节奏，完成了一次关于亲密关系的高强度对话实验。",
    tags: ["舞台感", "对话", "实验"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20dramatic%20red%20wall%20room%20with%20a%20single%20vintage%20velvet%20armchair%20and%20warm%20desk%20lamp%2C%20deep%20shadow%2C%20minimal%20theatrical%20composition%2C%20rich%20crimson%20tones%2C%20high%20contrast&width=600&height=800&seq=passion-cover-019&orientation=portrait",
  },
  {
    id: "v-020",
    title: "秘密花园",
    type: "movie",
    category: "热门主题",
    region: "英国",
    year: 2024,
    duration: 111,
    publishDate: "2025-08-08",
    views: 1360000,
    rating: 8.4,
    director: "Eleanor Hayes",
    producer: "Thornfield Pictures",
    cast: ["Clara West", "James Ferrow"],
    summary: "庄园尽头的温室里，藏着一段跨越三十年的秘密。",
    description:
      "新任园艺师在庄园温室里发现一本被雨水浸透的日记，日记里记录的植物与眼前的温室一一对应。《秘密花园》以植物的生长周期作为叙事刻度，四季变化与人物情感同步推进，画面静谧而富有层次。",
    tags: ["庄园", "悬疑", "四季"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20victorian%20glass%20greenhouse%20at%20dusk%20filled%20with%20deep%20red%20flowers%20and%20warm%20lanterns%2C%20misty%20atmosphere%2C%20moody%20european%20estate%2C%20elegant%20film%20aesthetic&width=600&height=800&seq=passion-cover-020&orientation=portrait",
  },
  {
    id: "v-021",
    title: "热带夜色",
    type: "movie",
    category: "热门主题",
    region: "泰国",
    year: 2025,
    duration: 101,
    publishDate: "2025-07-30",
    views: 2860000,
    rating: 8.7,
    director: "P. Somchai",
    producer: "Bangkok Frame",
    cast: ["Nara", "Anan", "Ploy"],
    summary: "海岛夜市的霓虹下，一场没有说出口的告别正在进行。",
    description:
      "海岛夜市的最后一晚，女主在摊位间穿行，寻找一件再也不会有人来取的东西。影片用大量跟拍与手持镜头捕捉夜市的热闹，再在喧闹中安静下来，形成强烈的情绪落差。",
    tags: ["海岛", "夜市", "告别"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20tropical%20night%20market%20with%20colorful%20lanterns%20and%20red%20neon%20signs%2C%20humid%20haze%2C%20dark%20warm%20tones%2C%20bokeh%20lights%2C%20moody%20travel%20film%20photography&width=600&height=800&seq=passion-cover-021&orientation=portrait",
  },
  {
    id: "v-022",
    title: "光影之间",
    type: "movie",
    category: "激情电影",
    region: "中国大陆",
    year: 2025,
    duration: 126,
    publishDate: "2025-07-22",
    views: 2080000,
    rating: 8.6,
    director: "孙砚",
    producer: "蓝汐影视",
    cast: ["沈蔚", "顾宸", "周斯羽"],
    summary: "电影摄影棚里，两位演员在光影之间反复寻找一次真实的情绪。",
    description:
      "一部关于「表演」的电影。导演把拍摄现场本身作为舞台，让虚构与真实的界限不断被打散。全片的光影设计极为讲究，每一场戏的布光都与人物心理状态一一对应，是近年少见的元电影尝试。",
    tags: ["元电影", "表演", "摄影"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20film%20studio%20with%20a%20single%20spotlight%20cutting%20through%20darkness%20and%20haze%2C%20vintage%20camera%20silhouette%2C%20deep%20red%20gel%20light%2C%20dramatic%20theatrical%20atmosphere&width=600&height=800&seq=passion-cover-022&orientation=portrait",
  },
  {
    id: "v-023",
    title: "凌晨四点的信",
    type: "short",
    category: "激情短视频",
    region: "中国大陆",
    year: 2025,
    duration: 13,
    publishDate: "2025-07-15",
    views: 1960000,
    rating: 8.3,
    director: "方南",
    producer: "激情视频自制",
    cast: ["林晓", "宋辞"],
    summary: "凌晨四点的便利店门口，一封手写信被交到了一个陌生人的手里。",
    description:
      "《凌晨四点的信》是「夜行三部曲」的第三部，延续了同一世界观的便利店场景。全片以手写信的朗读作为旁白，画面在街道、便利贴与路灯之间切换，温柔而不煽情。",
    tags: ["夜戏", "书信", "系列作"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20handwritten%20letter%20on%20a%20dark%20wooden%20table%20lit%20by%20warm%20amber%20street%20lamp%20glow%2C%20red%20wax%20seal%2C%20shallow%20depth%20of%20field%2C%20moody%20night%20atmosphere&width=600&height=800&seq=passion-cover-023&orientation=portrait",
  },
  {
    id: "v-024",
    title: "热带微光",
    type: "short",
    category: "激情短视频",
    region: "新加坡",
    year: 2025,
    duration: 5,
    publishDate: "2025-07-08",
    views: 3240000,
    rating: 8.9,
    director: "Tan Wei",
    producer: "Equator Studio",
    cast: ["Yuki Lam", "Isaac Lim"],
    summary: "五分钟的黄昏，够说完一整个夏天的喜欢。",
    description:
      "片中只有一个固定场景：组屋走廊的黄昏。光线从暖暖的橙色逐渐变成深红，两个人的身影从长到短，再从短到长。导演用五分钟的光线变化，讲完了最有耐心的告白。",
    tags: ["黄昏", "极短篇", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20tropical%20apartment%20corridor%20bathed%20in%20deep%20orange%20sunset%20light%2C%20long%20shadows%20on%20concrete%20walls%2C%20warm%20dusty%20air%2C%20minimal%20nostalgic%20composition&width=600&height=800&seq=passion-cover-024&orientation=portrait",
  },
  {
    id: "v-025",
    title: "双人舞",
    type: "movie",
    category: "激情电影",
    region: "阿根廷",
    year: 2024,
    duration: 114,
    publishDate: "2025-06-30",
    views: 1520000,
    rating: 8.5,
    director: "Mateo Silva",
    producer: "Tango House",
    cast: ["Valeria Sosa", "Diego Paz"],
    summary: "探戈舞厅里，两支最骄傲的舞者学会了一起退让。",
    description:
      "整部影片围绕一场舞厅比赛展开，几乎所有关键情节都以探戈舞步表达。导演特意使用长镜头完整记录每一支舞，让观众能够真实感受到舞者之间的力量博弈与情绪变化。",
    tags: ["舞蹈", "竞技", "情感"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20tango%20dance%20floor%20in%20a%20dim%20ballroom%20with%20deep%20red%20curtains%20and%20warm%20spotlights%2C%20motion%20blur%20of%20dancers%2C%20rich%20crimson%20and%20black%20tones%2C%20elegant%20dramatic&width=600&height=800&seq=passion-cover-025&orientation=portrait",
  },
  {
    id: "v-026",
    title: "玻璃房",
    type: "movie",
    category: "热门主题",
    region: "德国",
    year: 2023,
    duration: 109,
    publishDate: "2025-06-22",
    views: 1180000,
    rating: 8.1,
    director: "Hanna Weiss",
    producer: "Nordlicht",
    cast: ["Marlene Kraus", "Tobias Rehm"],
    summary: "一栋透明玻璃房里的两个人，被所有邻居看得一清二楚，却谁也不肯先退让。",
    description:
      "影片设定在一个完全不设窗帘的社区，所有生活都在他人视线中展开。玻璃的反射与透视被反复运用，构成一则关于隐私与亲密的现代寓言。画面极简，色彩克制，是本年度最具思辨性的作品之一。",
    tags: ["实验", "现代", "寓言"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20modern%20glass%20house%20at%20night%20with%20warm%20red%20interior%20light%20spilling%20out%2C%20reflections%20on%20glass%20facade%2C%20minimal%20architectural%20photography%2C%20dark%20sky%2C%20high%20contrast&width=600&height=800&seq=passion-cover-026&orientation=portrait",
  },
  {
    id: "v-027",
    title: "旧唱片店",
    type: "movie",
    category: "激情电影",
    region: "日本",
    year: 2025,
    duration: 95,
    publishDate: "2025-06-14",
    views: 1440000,
    rating: 8.2,
    director: "森田启",
    producer: "东京夜行社",
    cast: ["水野绫", "佐伯遥"],
    summary: "唱片店里那首没人买的黑胶，是两个人共同的秘密暗号。",
    description:
      "女主角每周三都会来唱片店试听同一张唱片，而店主早已为她准备好耳机。影片用唱片侧标、封套与唱针特写构建视觉节奏，配合整张专辑的音乐结构，讲述一段含蓄而绵长的情感。",
    tags: ["音乐", "怀旧", "日常"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20vinyl%20records%20in%20wooden%20crates%20with%20a%20turntable%20needle%20close%20up%2C%20warm%20amber%20shop%20light%2C%20deep%20red%20accents%2C%20nostalgic%20analog%20aesthetic%2C%20moody%20photography&width=600&height=800&seq=passion-cover-027&orientation=portrait",
  },
  {
    id: "v-028",
    title: "她的房间",
    type: "movie",
    category: "激情电影",
    region: "中国台湾",
    year: 2024,
    duration: 103,
    publishDate: "2025-06-05",
    views: 1290000,
    rating: 8.3,
    director: "杨以安",
    producer: "岛屿影画",
    cast: ["林宛静", "吴念"],
    summary: "第一次走进她的房间，才发现墙上贴满了自己的照片。",
    description:
      "影片以一个下午的时间跨度展开，几乎所有情节都发生在女主角的房间内。墙上的照片、床头的旧物、窗外的光，成为揭开悬念的关键。导演用大量特写引导观众注意细节，二刷时会看到完全不同的故事。",
    tags: ["悬疑", "室内剧", "情感"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20cozy%20bedroom%20wall%20covered%20with%20many%20small%20photographs%20lit%20by%20warm%20afternoon%20light%2C%20sheer%20curtain%20glow%2C%20deep%20red%20blanket%2C%20intimate%20moody%20interior&width=600&height=800&seq=passion-cover-028&orientation=portrait",
  },
  {
    id: "v-029",
    title: "夜游",
    type: "short",
    category: "激情短视频",
    region: "中国大陆",
    year: 2025,
    duration: 14,
    publishDate: "2025-05-28",
    views: 2410000,
    rating: 8.4,
    director: "程夏",
    producer: "激情视频自制",
    cast: ["苏可", "陆行"],
    summary: "凌晨的城市骑行，是一句不完整告白的全部注脚。",
    description:
      "全片在城市环路拍摄，机位始终跟在自行车后侧。路灯柱一根根掠过，形成极稳定的视觉节拍。片中几乎没有对白，所有情绪都交给夜晚的城市与配乐完成。",
    tags: ["骑行", "夜戏", "氛围感"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20bicycle%20silhouette%20riding%20down%20an%20empty%20city%20road%20at%20night%20with%20amber%20street%20lamps%20receding%2C%20motion%20blur%2C%20deep%20red%20tail%20light%20streaks%2C%20moody%20urban%20atmosphere&width=600&height=800&seq=passion-cover-029&orientation=portrait",
  },
  {
    id: "v-030",
    title: "夏末告白",
    type: "short",
    category: "激情短视频",
    region: "韩国",
    year: 2024,
    duration: 8,
    publishDate: "2025-05-20",
    views: 2870000,
    rating: 8.7,
    director: "尹智浩",
    producer: "Studio Beat",
    cast: ["金敏书", "郑宇镇"],
    summary: "夏天结束前的最后一班公交，说了那句迟到两年的话。",
    description:
      "公交车的最后一排，两个人在摇晃的车厢里完成了全片唯一一次对视。影片用手持镜头拍摄车厢晃动的节奏，配合逐渐暗下的窗外光线，把夏末的情绪留在了最后一秒。",
    tags: ["青春", "夏日", "告白"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20an%20empty%20bus%20window%20at%20dusk%20with%20warm%20red%20sunset%20light%20and%20blurred%20street%20trees%2C%20reflection%20on%20glass%2C%20nostalgic%20melancholic%20mood%2C%20film%20grain&width=600&height=800&seq=passion-cover-030&orientation=portrait",
  },
];